import { render, staticRenderFns } from "./StatCharts.vue?vue&type=template&id=2de05c6c&scoped=true"
import script from "./StatCharts.vue?vue&type=script&lang=js"
export * from "./StatCharts.vue?vue&type=script&lang=js"
import style0 from "./StatCharts.vue?vue&type=style&index=0&id=2de05c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de05c6c",
  null
  
)

export default component.exports